import React from "react";
import { Mail, Phone, MapPin, Instagram } from "lucide-react";

const WhatsAppIcon = ({ className = "w-5 h-5" }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
  </svg>
);

const Footer = ({
  onNavigate,
  onOpenSizeGuide,
  onOpenShippingInfo,
  onOpenReturns,
}) => {
  return (
    <footer className="bg-gradient-to-br from-[#0f0f2e] via-[#1a1a3e] to-[#0f0f2e] text-white mt-20">
      <div className="px-4 py-16 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 mb-12 md:grid-cols-4">
          <div className="space-y-4">
            <h3 className="text-2xl font-serif text-transparent bg-clip-text bg-gradient-to-r from-[#d4af37] to-[#f0d98f]">
              MAISON DE BIJOUX
            </h3>
            <p className="text-sm leading-relaxed text-gray-400">
              Discover the essence of elegance in handcrafted Silver 925
              jewellery — designed to reflect your individuality.
            </p>
            <div className="flex space-x-4">
              <button
                onClick={() =>
                  window.open("https://wa.me/+96179498090", "_blank")
                }
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#d4af37] transition"
              >
                <WhatsAppIcon className="w-5 h-5" />
              </button>
              <button
                onClick={() =>
                  window.open(
                    "https://www.instagram.com/maison_bijouxx?igsh=aWx4bWNsZ2lydW44",
                    "_blank"
                  )
                }
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#d4af37] transition"
              >
                <Instagram className="w-5 h-5" />
              </button>
              {/* <button
                onClick={() => window.open("https://twitter.com", "_blank")}
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-[#d4af37] transition"
              >
                <Twitter className="w-5 h-5" />
              </button> */}
            </div>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-4 text-[#d4af37]">Shop</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => onNavigate("shop")}
                  className="text-gray-400 hover:text-[#d4af37] transition text-sm"
                >
                  Collections
                </button>
              </li>
              <li>
                <button
                  onClick={() => onNavigate("wishlist")}
                  className="text-gray-400 hover:text-[#d4af37] transition text-sm"
                >
                  Your Favorites
                </button>
              </li>
              <li>
                <button
                  onClick={() => onNavigate("shop", { category: "Rings" })}
                  className="text-gray-400 hover:text-[#d4af37] transition text-sm"
                >
                  Rings
                </button>
              </li>
              <li>
                <button
                  onClick={() => onNavigate("shop", { category: "Necklaces" })}
                  className="text-gray-400 hover:text-[#d4af37] transition text-sm"
                >
                  Necklaces
                </button>
              </li>
              <li>
                <button
                  onClick={() => onNavigate("shop", { category: "Earrings" })}
                  className="text-gray-400 hover:text-[#d4af37] transition text-sm"
                >
                  Earrings
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-4 text-[#d4af37]">
              Customer Service
            </h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => onNavigate("contact")}
                  className="text-gray-400 hover:text-[#d4af37] transition text-sm"
                >
                  Get in touch
                </button>
              </li>
              <li>
                <button
                  onClick={onOpenShippingInfo}
                  className="text-gray-400 hover:text-[#d4af37] transition text-sm"
                >
                  Shipping Info
                </button>
              </li>
              <li>
                <button
                  onClick={onOpenReturns}
                  className="text-gray-400 hover:text-[#d4af37] transition text-sm"
                >
                  Returns
                </button>
              </li>
              <li>
                <button
                  onClick={onOpenSizeGuide}
                  className="text-gray-400 hover:text-[#d4af37] transition text-sm"
                >
                  Size Guide
                </button>
              </li>
              <li>
                <button
                  onClick={() => onNavigate("about")}
                  className="text-gray-400 hover:text-[#d4af37] transition text-sm"
                >
                  Our Story
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-lg mb-4 text-[#d4af37]">
              Get in touch
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3 text-sm text-gray-400">
                <MapPin className="w-5 h-5 text-[#d4af37] flex-shrink-0 mt-0.5" />
                <span>
                  Tripoli
                  <br />
                  North Lebanon
                </span>
              </li>
              <li className="flex items-center space-x-3 text-sm text-gray-400">
                <Phone className="w-5 h-5 text-[#d4af37] flex-shrink-0" />
                <span>+961 79 498 090</span>
              </li>
              <li className="flex items-center space-x-3 text-sm text-gray-400">
                <Mail className="w-5 h-5 text-[#d4af37] flex-shrink-0" />
                <span>maisondebijoux.lb@gmail.com</span>
              </li>
            </ul>
          </div>
        </div>

        {/* <div className="pt-8 mb-8 border-t border-gray-700">
          <div className="max-w-md mx-auto text-center">
            <h4 className="mb-2 text-lg font-semibold">
              Subscribe to our newsletter
            </h4>
            <p className="mb-4 text-sm text-gray-400">
              Get exclusive offers and updates on new collections
            </p>
            <div className="flex gap-2">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 px-4 py-3 rounded-full bg-white/10 border border-gray-600 focus:outline-none focus:border-[#d4af37] text-white placeholder-gray-500"
              />
              <button className="bg-gradient-to-r from-[#d4af37] to-[#c49a2e] px-6 py-3 rounded-full font-semibold hover:from-[#c49a2e] hover:to-[#b38b28] transition">
                Subscribe
              </button>
            </div>
          </div>
        </div> */}

        <div className="flex flex-col items-center justify-between pt-8 text-sm text-gray-400 border-t border-gray-700 md:flex-row">
          <p> {new Date().getFullYear()} Maison de Bijoux. </p>
          {/* <div className="flex mt-4 space-x-6 md:mt-0">
            <button className="hover:text-[#d4af37] transition">
              Privacy Policy
            </button>
            <button className="hover:text-[#d4af37] transition">
              Terms of Service
            </button>
          </div> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
